import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PaypalProxy = lazyWithPreload(() => import('./paypalProxy'))
